module.exports = __webpack_public_path__ + "fonts/inter-latin.260c81a4.woff2";